import { format, isValid } from 'date-fns';

/**
 * Combines `date` and `time` objects into a single formatted date and time.
 * @param date - The date string in `yyyy-MM-dd` format.
 * @param time - The time string in `HHmm` format (24-hour clock).
 * @returns Object containing formatted date and formatted time.
 */
export const formatDateTime = (
  date: string,
  time: string,
): { formattedDate: string; formattedTime: string; fullDateTime: string } => {
  // Combine date and time into a full ISO string (e.g., '2025-05-25T12:00')
  const fullDateTime = `${date}T${time.slice(0, 2)}:${time.slice(2, 4)}`;
  const parsedDate = new Date(fullDateTime);
  if (!isValid(parsedDate)) {
    return { formattedDate: '', formattedTime: '', fullDateTime };
  }
  return {
    formattedDate: format(parsedDate, 'yyyy-MM-dd'),
    formattedTime: format(parsedDate, 'hh:mm a'),
    fullDateTime,
  };
};
